/** Selected Mandistry Dispatch mark; CSS follows the app's resolved theme. */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <span className="inline-flex shrink-0" aria-hidden="true">
      <img className="brand-logo-dark" src="/branding/logo-dark.svg" width={size} height={size} alt="" />
      <img className="brand-logo-light" src="/branding/logo-light.svg" width={size} height={size} alt="" />
    </span>
  );
}
